import { deleteMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DELETE_QUESTIONNAIRE_LIST = 'DELETE_QUESTIONNAIRE_LIST';
export const DELETE_QUESTIONNAIRE_LIST_SUCCESS =
  'DELETE_QUESTIONNAIRE_LIST_SUCCESS';
export const DELETE_QUESTIONNAIRE_LIST_FAILURE =
  'DELETE_QUESTIONNAIRE_LIST_FAILURE';

// Action Creators
export const deleteQuestionnaireList = () => ({
  type: DELETE_QUESTIONNAIRE_LIST,
});

export const deleteQuestionnaireListSuccess = (users) => ({
  type: DELETE_QUESTIONNAIRE_LIST_SUCCESS,
  payload: users,
});

export const deleteQuestionnaireListFailure = (error) => ({
  type: DELETE_QUESTIONNAIRE_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteQuestionnaireData = (external, id) => {
  return async (dispatch) => {
    dispatch(deleteQuestionnaireList());
    try {
      const response = await deleteMethodWithToken(
        url?.deleteQuestionnaireList + id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(deleteQuestionnaireListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(deleteQuestionnaireListFailure('error?.message'));
      }
    } catch (error) {
      dispatch(deleteQuestionnaireListFailure(error?.message));
    }
  };
};
